import React from "react"
import * as Yup from "yup"
import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import { allStates } from "helpers/utils"
import { useCreateHelpMutation } from "store/api/user/help.api"
import toast from "react-hot-toast"
import { useFormik } from "formik"
import Spinners from "components/Common/Spinner"

const defaultValue = { message: "" }

function HelpModel({ open, setOpen, onSuccess }) {
  const [mutate, { isLoading }] = useCreateHelpMutation()

  const toggle = () => setOpen(!open)

  const handleHelp = async (values) => {
    try {
      const { success, message } = await mutate(values).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        onSuccess(false)
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "inviteToastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: defaultValue,
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      handleHelp(values)
    },
  })

  const onCancel = () => {
    setOpen(false)
  }

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered>
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Need Help?
        </ModalHeader>
        <ModalBody>
          <h5 className="mb-3"></h5>
          <Container>
            <div className="form-horizontal">
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row className="mb-2">
                  <Col xl={12} className="mb-2">
                    <Label className="form-label">Describe Your Problem</Label>
                    <textarea
                      name="message"
                      type="text"
                      className="form-control"
                      onChange={validation.handleChange}
                      value={validation.values.message}
                    />
                    {validation.touched.message && validation.errors.message ? (
                      <FormFeedback type="invalid">
                        {validation.errors.message}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </Row>

                <div className="mt-3 py-1 button-wrapper">
                  <Button className="cancel" onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button type="submit" color="primary">
                    {isLoading ? <Spinners /> : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default HelpModel
